import { Typography } from '@mui/material'
import { useTranslation } from 'next-i18next'
import { MarkdownDisplay } from 'components/common/MarkdownDisplay/MarkdownDisplay'
import { replaceMarkdownEmptyParagraphs } from 'helpers/string'
import {
  BodyContainer,
  OrganizerContainer,
  PracticalInformationContent
} from './map/Organizer.style'

interface PracticalInformationProps {
  content: string
}
const PracticalInformation = ({ content }: PracticalInformationProps) => {
  const { t } = useTranslation('event')
  return (
    <OrganizerContainer>
      <BodyContainer>
        <Typography variant="h4">{t('practicalInformation')}</Typography>
      </BodyContainer>
      <PracticalInformationContent margin="24px 0 0">
        <MarkdownDisplay>
          {replaceMarkdownEmptyParagraphs(content)}
        </MarkdownDisplay>
      </PracticalInformationContent>
    </OrganizerContainer>
  )
}

export default PracticalInformation
